import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    gtag('config', 'UA-139039345-1', {'page_path': to.path});
    next();
});

Vue.mixin({
    methods: {
        findObjectByKey : function (array, key, value)
        {
            for (var i = 0; i < array.length; i++)
            {
                if (array[i][key].toLowerCase() === value.toLowerCase())
                {
                    return array[i];
                }
            }
            return null;
        },
        removeObjectByKeyReturnArray : function (array, key, value)
        {
            for (var i = 0; i < array.length; i++)
            {
                if (array[i][key].toLowerCase() === value.toLowerCase())
                {
                    var arrayCopy = array.slice(0);
                    arrayCopy.splice(i, 1);
                    return arrayCopy;
                }
            }
            return null;
        },
        isObjectEmpty : function(obj)
        { 
            for (var prop in obj)
            { 
                return false; 
            } 
            return true; 
        },
        updateSeo : function(data, pageName)
        {
            var seoData = this.findObjectByKey(data, "PageName", pageName);
            document.title = seoData.Title;
            this.findObjectByKey(document.getElementsByTagName("META"), "name", "description").content = seoData.Description;

            if(document.title == "Newswire | Hunter NYC")
            {
                var link = document.createElement('meta');
                link.setAttribute('name', 'twitter:image');
                link.content = "http://hunterpr.com/foodstudy_coronavirus/images/twshare2020-new.png";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('name', 'twitter:card');
                link.content = "summary";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('name', 'twitter:site');
                link.content = "@hunterpr";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('name', 'twitter:title');
                link.content = "Hunter Food Study Special Report";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('name', 'twitter:description');
                link.content = "View the report";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('property', 'og:image');
                link.content = "http://hunterpr.com/foodstudy_coronavirus/images/twshare2020-new.png";
                document.getElementsByTagName('head')[0].appendChild(link);

                link = document.createElement('meta');
                link.setAttribute('name', 'image');
                link.setAttribute('property', 'og:image');
                link.content = "http://hunterpr.com/foodstudy_coronavirus/images/twshare2020-new.png";
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            else
            {
                var e = document.querySelector("[name='twitter:image']");
                if (e != null)
                {
                    document.querySelector("[name='twitter:image']").remove();
                    document.querySelector("[name='twitter:card']").remove();
                    document.querySelector("[name='twitter:site']").remove();
                    document.querySelector("[name='twitter:title']").remove();
                    document.querySelector("[name='twitter:description']").remove();
                    document.querySelector("[name='og:image']").remove();
                    document.querySelector("[name='image']").remove();
                }
            }
        }
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
